import {SODeletePerson} from '../../core/person/so-delete-person';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeletePerson extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeletePerson;
}